import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { alpha, Box, Chip, Stack, Typography } from "@mui/material";

export const RollInfo = ({
	position,
	name,
	diameter,
	wasSwapped,
}: {
	position: "top" | "bottom";
	name: string | null;
	diameter: number | null;
	wasSwapped: boolean;
}) => {
	const isTop = position === "top";
	const Icon = isTop ? KeyboardArrowUp : KeyboardArrowDown;

	return (
		<Stack direction="row" spacing={1.5} alignItems="center">
			<Box
				sx={{
					width: 32,
					height: 32,
					borderRadius: "50%",
					backgroundColor: alpha(isTop ? "#3b82f6" : "#8b5cf6", 0.1),
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Icon
					sx={{
						fontSize: 16,
						color: isTop ? "#3b82f6" : "#8b5cf6",
					}}
				/>
			</Box>
			<Box sx={{ flex: 1 }}>
				<Stack direction="row" alignItems="center" spacing={0.75}>
					<Typography variant="body2" fontWeight={600}>
						{name || "—"}
					</Typography>
					{wasSwapped && (
						<Chip
							label={isTop ? "Old Bottom" : "Old Top"}
							size="small"
							sx={{
								height: 16,
								fontSize: "0.6rem",
								backgroundColor: (theme) =>
									alpha(theme.palette.warning.main, 0.15),
								color: (theme) => theme.palette.warning.main,
								"& .MuiChip-label": { px: 0.75 },
							}}
						/>
					)}
				</Stack>
				<Typography variant="caption" color="text.secondary">
					{diameter?.toFixed(3) || "—"}
				</Typography>
			</Box>
		</Stack>
	);
};
